import type { CalendarSurfaceOptions } from 'owa-outlook-service-option-store';
import { lazyCreateOrUpdateOptionsForFeature, lazyLoadOptions } from 'owa-outlook-service-options';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-option-store';

export function updateNumDaysInDayRangeStoredValue(newValue: number): void {
    const userOptions = getOptionsForFeature<CalendarSurfaceOptions>(
        OwsOptionsFeatureType.CalendarSurfaceOptions
    );
    if (userOptions.numDaysInDayRange != newValue) {
        userOptions.numDaysInDayRange = newValue;
    }
}
export async function updateNumDaysInDayRangeServerValue(newValue: number): Promise<void> {
    await lazyLoadOptions.importAndExecute();
    const userOptions = getOptionsForFeature<CalendarSurfaceOptions>(
        OwsOptionsFeatureType.CalendarSurfaceOptions
    );
    lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.CalendarSurfaceOptions,
        {
            ...userOptions,
            numDaysInDayRange: newValue,
        } as CalendarSurfaceOptions
    );
}
